import React from 'react';

import type { IAirdropBox } from '@type/airdrop';
import { I18n } from '@utils/index';

import { useUsdtValue } from '../hooks/useUsdtValue';
import { Lottie } from '../Lottie';
import { ModalProps, openModalIconClose } from './ModalIconClose';

import styles from './index.module.less';

interface ContentProps {
  /** 空投箱类型 */
  name: IAirdropBox;
  /** 获得金额 */
  money: number;
  /** 币种 */
  coinCode: string;
  /** 关闭弹窗 */
  closeModal: () => void;
  resolve: ModalProps['resolve'];
}

const Content: React.FC<ContentProps> = (props) => {
  const { name, money, closeModal, resolve, coinCode } = props;

  const count = useUsdtValue({ coinCode, count: money });
  // 动画播放完成
  const onFinish = () => {
    closeModal();
    resolve()
  }
  return (
    <div className={styles.lottieWrapper}>
      <Lottie name={name} className={styles.lottie} onFinish={onFinish} />
      <div className={styles.activeBottom}>
        <p className={styles.activeTitle}>{I18n.t('5pEtvQL3', { money, coinCode: coinCode })}</p>
        <p className={styles.activeDesc}>{count}</p>
      </div>
    </div>
  );
}

interface IOpenModalIconCloseParams extends Pick<ContentProps, 'money' | 'name' | 'coinCode'> {
  el: HTMLElement;
}

export const openActiveModal = ({ el, ...rest }: IOpenModalIconCloseParams) => {
  return openModalIconClose({
    el,
    children: (params) => <Content {...rest} closeModal={params.removePreview} resolve={params.resolve} />
  })
}
